// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","ModalContent":"Modal_ModalContent__23meR"};